import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { postForm } from '../utils/api';
import apiUtils from '../utils/api';
import '../index.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  // 检查用户是否已经登录，如果已登录则自动跳转到dashboard
  useEffect(() => {
    if (apiUtils.isAuthenticated()) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 构建表单数据
      const formData = new URLSearchParams();
      formData.append('grant_type', 'password');
      formData.append('username', values.username);
      formData.append('password', values.password);

      // 使用API工具类发送登录请求
      const data = await postForm('/token', formData, { requiresAuth: false });

      // 保存登录信息到本地存储
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('token_type', data.token_type);
      localStorage.setItem('expires_in', data.expires_in);
      localStorage.setItem('userName', data.userName);
      localStorage.setItem('algoChainToken', data.algoChainToken);
      localStorage.setItem('.issued', data['.issued']);
      localStorage.setItem('.expires', data['.expires']);

      console.log('登录成功:', data);
      message.success(t('login.loginSuccess'));

      // 登录成功后跳转到首页
      navigate('/wizard');
    } catch (error) {
      console.error('登录失败:', error);
      message.error(t('login.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-form">
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
            Algo-Chain HK
          </h2>
        </div>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1 className="login-title" style={{ margin: 0 }}>{t('login.title')}</h1>
            <LanguageSwitcher />
          </Space>

          <Form
            name="login"
            initialValues={{
              remember: true,
              username: '',
              password: ''
            }}
            onFinish={onFinish}
            size="large"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: t('login.usernameRequired') }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder={t('login.usernamePlaceholder')}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: t('login.passwordRequired') }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder={t('login.passwordPlaceholder')}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
              >
                {t('login.loginButton')}
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </Card>
    </div>
  );
};

export default Login;